/// <reference path="../wpt.ts" />
var WPTNamespace;
(function (WPTNamespace) {
    var Widgets;
    (function (Widgets) {
        const LOG_CATEGORY = "WPT.Components.OptionInput";
        const DELAY_TIME = 100;
        const CHANGE_EVENT = new Event('change');
        class ComponentOptionInput extends Widgets.ComponentBaseClass {
            constructor(core, container, parent, config) {
                super(core, container, parent);
                this._config = null;
                this._options = null;
                this._input = null;
                this._optionsParent = null;
                this._optionsHolder = null;
                this._datalist = null;
                this._lastSelectedOption = null;
                this._valueMustExist = null;
                this._allowEmptyValue = null;
                this._showClearIcon = null;
                this._useExternalParent = null;
                this._currentActiveIndex = -1;
                this.hideOptions = () => {
                    this._log.info("ComponentOptionInput._hideOptions()");
                    if (!this._optionsHolder.classList.contains(WPTNamespace.HIDDEN_CLASS)) {
                        this._core.Functions.hideElement(this._optionsHolder);
                        this._clearActiveOption();
                    }
                };
                this._present = () => {
                    this._log.info("ComponentOptionInput._present()");
                    let fragment = document.createDocumentFragment();
                    if (this._input === null) {
                        this._input = document.createElement('input');
                        fragment.appendChild(this._input);
                        this._input.classList.add('wpt-input__input');
                        this._input.autocomplete = "off";
                        let iconDiv = document.createElement('div');
                        fragment.appendChild(iconDiv);
                        iconDiv.classList.add('wpt-input__icons', 'wpt-input__icons--last');
                        let showOptionsSpan = document.createElement('span');
                        iconDiv.appendChild(showOptionsSpan);
                        showOptionsSpan.classList.add("wpt-input__icons-item", "wpt-input__icons-item--hover-primary", "wpt-font", "wpt-font-icon_Down");
                        showOptionsSpan.addEventListener('click', this._toggleOptions);
                        if (this._showClearIcon) {
                            showOptionsSpan.classList.add("wpt-input__icons-item--gap-to-right");
                            let clearSpan = document.createElement('span');
                            iconDiv.appendChild(clearSpan);
                            clearSpan.classList.add("wpt-input__icons-item", "wpt-input__icons-item--hover-error", "wpt-font", "wpt-font-icon_CloseCircle");
                            clearSpan.addEventListener('click', this._clearOptions);
                        }
                    }
                    this._optionsHolder = document.createElement('div');
                    this._optionsHolder.classList.add('wpt-input__options', WPTNamespace.HIDDEN_CLASS);
                    let optionsBody = document.createElement('div');
                    this._optionsHolder.appendChild(optionsBody);
                    optionsBody.classList.add('wpt-input__options-body');
                    let optionsFooter = document.createElement('div');
                    this._optionsHolder.appendChild(optionsFooter);
                    optionsFooter.classList.add('wpt-input__options-footer');
                    if (this._useExternalParent) {
                        this._optionsParent.appendChild(this._optionsHolder);
                    }
                    else {
                        fragment.appendChild(this._optionsHolder);
                    }
                    this._container.appendChild(fragment);
                    let listConfig = {
                        SelectItemCallback: this._optionClicked
                    };
                    this._datalist = new Widgets.ComponentDataList(this._core, optionsBody, this._parent, listConfig);
                    this._datalist.present();
                    this._datalist.displayData(this._options);
                    this._input.addEventListener('focus', this._showOptions);
                    this._input.addEventListener('click', this._showOptions);
                    this._input.addEventListener('keyup', this._handleKeys);
                    this._input.addEventListener('blur', this._hideOptionsDelayed);
                    this._input.addEventListener('change', this._inputChanged);
                };
                this._toggleOptions = () => {
                    this._log.info("ComponentOptionInput._toggleOptions()");
                    if (this._optionsHolder.classList.contains(WPTNamespace.HIDDEN_CLASS)) {
                        this._showOptions();
                    }
                    else {
                        this.hideOptions();
                    }
                };
                this._showOptions = () => {
                    this._log.info("ComponentOptionInput._showOptions()");
                    if (this._optionsHolder.classList.contains(WPTNamespace.HIDDEN_CLASS)) {
                        this._datalist.filterItems('');
                        this._core.Functions.showElement(this._optionsHolder);
                        if (this._useExternalParent) {
                            if (this._log.isTraceEnabled()) {
                                this._log.trace("using external options parent need to set position");
                            }
                            let inputRect = this._input.getBoundingClientRect();
                            if (this._log.isTraceEnabled()) {
                                this._log.trace("input element: bottom=" + inputRect.bottom + ", left=" + inputRect.left);
                            }
                            let optionsParentRect = this._optionsHolder.offsetParent.getBoundingClientRect();
                            if (this._log.isTraceEnabled()) {
                                this._log.trace("options parent element: top=" + optionsParentRect.top + ", left=" + optionsParentRect.left);
                            }
                            let top = inputRect.bottom - optionsParentRect.top;
                            let left = inputRect.left - optionsParentRect.left;
                            if (this._log.isTraceEnabled()) {
                                this._log.trace("resulting position: top=" + top + ", left=" + left);
                            }
                            this._optionsHolder.style.top = top + 'px';
                            this._optionsHolder.style.left = left + 'px';
                        }
                    }
                };
                this._optionClicked = (idString) => {
                    this._log.info("ComponentOptionInput._optionClicked()");
                    this.hideOptions();
                    let optionData = this._options.Items.find(opt => opt.Id == idString);
                    this._input.value = optionData.DisplayName;
                    this._input.dispatchEvent(CHANGE_EVENT);
                };
                this._handleKeys = (event) => {
                    this._log.info("ComponentOptionInput._handleKeys()");
                    if (event.key === 'ArrowDown') {
                        this._currentActiveIndex++;
                        this._setActiveOption();
                    }
                    else if (event.key === 'ArrowUp') {
                        this._currentActiveIndex--;
                        this._setActiveOption();
                    }
                    else if (event.key === 'Enter') {
                        let activeItem = this._datalist.getActiveItem();
                        if (activeItem) {
                            activeItem.click();
                        }
                    }
                    else {
                        this._filterOptions();
                    }
                };
                this._setActiveOption = () => {
                    this._log.info("ComponentOptionInput._setActiveOption()");
                    this._currentActiveIndex = this._datalist.setActiveItem(this._currentActiveIndex);
                    let activeItem = this._datalist.getActiveItem();
                    if (activeItem) {
                        let optionsRect = this._optionsHolder.getBoundingClientRect();
                        let currentScrollTop = this._optionsHolder.scrollTop;
                        if (this._log.isTraceEnabled()) {
                            this._log.trace("options: top=" + optionsRect.top + ", height=" + optionsRect.height + ", scrollTop=" + currentScrollTop);
                        }
                        let activeRect = activeItem.getBoundingClientRect();
                        if (this._log.isTraceEnabled()) {
                            this._log.trace("active option: top=" + activeRect.top + ", height=" + activeRect.height);
                        }
                        let scrollTop = activeRect.top - optionsRect.top;
                        if (this._log.isTraceEnabled()) {
                            this._log.trace("active option: scrollTop=" + scrollTop);
                        }
                        if (scrollTop < 0 || scrollTop + activeRect.height > optionsRect.height) {
                            if (this._log.isTraceEnabled()) {
                                this._log.trace("adjusting scrollTop by " + scrollTop);
                            }
                            this._optionsHolder.scrollTop = currentScrollTop + scrollTop;
                        }
                        if (this._log.isTraceEnabled()) {
                            this._log.trace("resulting scrollTop " + this._optionsHolder.scrollTop);
                        }
                    }
                };
                this._clearActiveOption = () => {
                    this._log.info("ComponentOptionInput._clearActiveOption()");
                    this._datalist.clearActiveItem();
                    this._currentActiveIndex = -1;
                };
                this._filterOptions = () => {
                    this._log.info("ComponentOptionInput._filterOptions()");
                    let filterText = this._input.value;
                    this._datalist.filterItems(filterText);
                    this._clearActiveOption();
                };
                this._hideOptionsDelayed = () => {
                    this._log.info("ComponentOptionInput._hideOptionsDelayed()");
                    setTimeout(this.hideOptions, DELAY_TIME); // need timeout here, to get click event on options
                };
                this._inputChanged = (event) => {
                    this._log.info("ComponentOptionInput._inputChanged()");
                    let value = this._input.value;
                    this._input.setCustomValidity('');
                    let validValue = true;
                    if (!this._allowEmptyValue && value.length == 0) {
                        validValue = false;
                        console.warn("empty value is not allowed");
                        this._input.setCustomValidity(this._core.Locale.getTranslation('STR_WPT_MUST_EXIST_IN_DATASET'));
                        this._input.reportValidity();
                    }
                    if (validValue && value && value.length > 0 && this._valueMustExist) {
                        let optionData = this._options.Items.find(opt => opt.DisplayName === value);
                        this._lastSelectedOption = optionData;
                        if (!optionData) {
                            validValue = false;
                            console.warn("value '" + value + "' isn't part of the options");
                            this._input.setCustomValidity(this._core.Locale.getTranslation('STR_WPT_MUST_EXIST_IN_DATASET'));
                            this._input.reportValidity();
                        }
                    }
                    if (validValue && this._config.ChangeCallback) {
                        this._config.ChangeCallback(event);
                    }
                };
                this._clearOptions = () => {
                    this._log.info("ComponentOptionInput._clearOptions()");
                    this.hideOptions();
                    this._input.value = '';
                    this._input.dispatchEvent(CHANGE_EVENT);
                };
                this._log = this._core.Logging.getLogger(LOG_CATEGORY);
                this._log.info("ComponentOptionInput::constructor");
                this._config = config;
                this._options = {
                    Items: []
                };
                if (this._config.hasOwnProperty('Options')) {
                    this._options = this._config.Options;
                }
                this._valueMustExist = true;
                if (this._config.hasOwnProperty('ValueMustExist')) {
                    this._valueMustExist = this._config.ValueMustExist;
                }
                this._input = null;
                if (this._config.hasOwnProperty('Input')) {
                    if (this._log.isTraceEnabled()) {
                        this._log.trace("using given input element");
                    }
                    this._input = this._config.Input;
                }
                this._optionsParent = null;
                this._useExternalParent = false;
                if (this._config.hasOwnProperty('OptionsParent')) {
                    if (this._log.isTraceEnabled()) {
                        this._log.trace("using given options parent element");
                    }
                    this._optionsParent = this._config.OptionsParent;
                    this._useExternalParent = true;
                }
                this._showClearIcon = false;
                if (this._config.hasOwnProperty('ShowClearIcon')) {
                    this._showClearIcon = this._config.ShowClearIcon;
                }
                this._allowEmptyValue = true;
                if (this._config.hasOwnProperty('AllowEmptyValue')) {
                    this._allowEmptyValue = this._config.AllowEmptyValue;
                }
                this._readyToPresent = true;
                if (this._waitingToPresent)
                    this._present();
            }
            get Input() {
                this._log.info("ComponentOptionInput.getInput()");
                return this._input;
            }
            get LastSelectedOption() {
                this._log.info("ComponentOptionInput.LastSelectedOption()");
                return this._lastSelectedOption;
            }
            set Options(options) {
                this._log.info("ComponentOptionInput.setOptions()");
                this._options = options;
                this._datalist.displayData(options);
            }
        }
        Widgets.ComponentOptionInput = ComponentOptionInput;
    })(Widgets = WPTNamespace.Widgets || (WPTNamespace.Widgets = {}));
})(WPTNamespace || (WPTNamespace = {}));
